<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Transportation Needs
                </h1>
                <div data-popover-target="popover-right" data-popover-placement="right" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-right" role="tooltip"
                    class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2">
                        <p>
                            Enter the number of each type of bus needed, then click
                            <span class="inline-flex px-3 py-1 items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white oswald-font">Save</span>.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
        </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start gap-8 overflow-y-auto">
        <div class="max-h-full w-full flex flex-col gap-4">
            <form #transportationForm="ngForm" (ngSubmit)="onSubmit()"
                class="h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col p-6 gap-4">
                <h2 class="oswald-font text-3xl text-nside-orange-400">Types of Buses Needed</h2>

                <div class="w-full flex flex-col divide-y divide-gray-200">
                    <div *ngFor="let bus of busTypes" class="flex flex-row items-center gap-4 py-3">
                        <div class="flex-1 min-w-0">
                            <p class="font-semibold text-gray-900">{{ bus.label }}</p>
                            <p class="text-sm text-gray-500">({{ bus.description }})</p>
                        </div>
                        <input *ngIf="canSave()" type="text" [name]="bus.key" [(ngModel)]="data[bus.key]"
                            class="w-40 shrink-0 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2"
                            placeholder="Number needed">
                        <p *ngIf="!canSave()" class="w-40 shrink-0 p-2 text-sm whitespace-pre-line break-words"
                            [ngClass]="(data[bus.key] !== null && data[bus.key] !== undefined && data[bus.key] !== '') ? 'text-gray-900' : 'text-gray-400 italic'">
                            {{ (data[bus.key] !== null && data[bus.key] !== undefined && data[bus.key] !== '') ? data[bus.key] : 'Empty' }}
                        </p>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-between">
                    <div *ngIf="data.last_updated_at" class="flex flex-col items-start">
                        <p class="oswald-font font-normal">
                            Last Updated At: <span class="raleway-font">{{ data.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</span>
                        </p>
                        <p class="oswald-font font-normal">
                            By: <span class="raleway-font">{{ data.last_updated_user_name || 'None' }}</span>
                        </p>
                    </div>
                    <button *ngIf="canSave()"
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white ml-auto border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200">
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>

    <prv-next-buttons></prv-next-buttons>
</main>

<introduction></introduction>

<popup-message [type]="messageModal" [message]="popupMessage" (close)="resetMessageModal()"></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
